import { writable } from "svelte/store";
import { browser } from "$app/environment";

export const langaugeStore = writable("English");

if (browser){
  langaugeStore.set(localStorage.getItem("language") || "English");
}
